export function objectToQueryString(data = {}) {
  const entries = Object.entries(data);
  if (entries.length === 0) {
    return '';
  }

  return entries.map(([key, value]) => `${key}=${value}`).join('&');
}
